import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "form"]

  reveal() {
    this.previewTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
  }
}
